<template>
  <div>
    <h3>All Subscribed Contacts <span>({{ count | prettyNumber }})</span></h3>
    <div class="sub-text">All subscribed contacts for emails</div>
    <DataTable :filter="'subscribed'" :count="count" />
  </div>
</template>
<script>
  import DataTable from './DataTable';

  export default {
    props: ['count'],
    components: {
      DataTable,
    },
    data() {
      return {};
    },
  };
</script>

